<template>
  <div>
    <qx-card title="订单风控" class="detail" v-loading="loading">
      <!-- 订单详情数据 -->
      <section v-if="!loading">
        <qx-detail-box
          v-for="(data, index) in detailData"
          :data="data"
          :key="index"
          labelWidth="220px"
        >
          <section slot="orderModify0" slot-scope="prop">
              {{prop.data.orderModify0 === '0' ? "开启" : "关闭"}}
          </section>
        </qx-detail-box>
        <!-- 订单详情数据 end -->
      </section>
      <p class="textCenter">
        <el-button type="primary" @click="toEdit" v-if="checkPermpisions('1100703')">修改</el-button>
      </p>
    </qx-card>
  </div>
</template>

<script>
import {
  orderLimitCfg,
} from 'api/system';
import {
  mapState,
} from 'vuex';
export default {
  props: {
    id: {
      type: Number,
    },
    type: {
      type: String,
    },
    handleRefresh: {
      type: Function,
      default: () => {},
    },
  },
  data () {
    return {
      loading: false,
      detailData: {
        orderInput: {
          label: '订单录入',
          tableData: {
            title: [
            ],
            data: {

            },
            approveData: {

            },
          },
        },
        orderModify: {
          label: '订单修改',
          tableData: {
            title: [
            ],
            data: {

            },
            approveData: {

            },
          },
        },
      },
    };
  },
  computed: {
    colSpan () {
      const total = 24;
      const minSpan = 4;
      return parseInt(total / this.orderInfo.length, 10) < minSpan ? minSpan : parseInt(total / this.orderInfo.length, 10);
    },
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
  },
  methods: {
    toEdit () {
      this.jump({
        label: '修改订单风控',
        url: '/manage/system/risk/order/edit?id=1',
      });
    },
    async getOrderCfgData () {
      const orderInputRes = await orderLimitCfg({
        typeName: 'ORDER_INPUT',
      });
      const orderModifyRes = await orderLimitCfg({
        typeName: 'ORDER_MODIFY',
      });

      if (!orderInputRes.failed) {
        this.detailData.orderInput.tableData.title = [];
        orderInputRes.items.forEach((item, index) => {
          this.detailData.orderInput.tableData.title.push({
            prop: `orderInput${index}`,
            label: item.name,
            remark: item.remark,
          });
          this.detailData.orderInput.tableData.data[`orderInput${index}`] = item.nameCode === 'WHITE_LIST_IDS' ? item.valueStr : item.value;
        });
      }

      if (!orderModifyRes.failed) {
        this.detailData.orderModify.tableData.title = [];
        orderModifyRes.items.forEach((item, index) => {
          let isSlot = item.name === '是否限制员工单次修改';
          this.detailData.orderModify.tableData.title.push({
            prop: `orderModify${index}`,
            label: item.name,
            remark: item.remark,
            slot: isSlot,
          });
          this.detailData.orderModify.tableData.data[`orderModify${index}`] = item.nameCode === 'WHITE_LIST_IDS' ? item.valueStr : item.value;
        });
      }

    },
    async getData () {
      this.loading = true;
      await this.getOrderCfgData();
      this.loading = false;
    },
  },
  mounted () {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
@import 'styles/config.scss';
.orderStatusBox {
  overflow: auto;
}
.orderInfoBox {
  margin: 16px 12px 0;
  min-height: 124px;
  border: 1px solid $border-color;
  padding: 24px 16px;
  box-sizing: border-box;
  .title {
    font-size: 16px;
    height: 16px;
    line-height: 16px;
    padding-bottom: 16px;
  }
  .desc,
  .time {
    color: #666;
    line-height: 16px;
  }
  .desc {
    padding-bottom: 12px;
  }
}
.box {
  border-top: 1px solid $border-color;
  border-left: 1px solid $border-color;
  border-right: 1px solid $border-color;
}
.itemLabel {
  background: $grey;
}
.itemLabel,
.itemText {
  height: 48px;
  line-height: 48px;
  padding: 0 24px;
  box-sizing: border-box;
  border-bottom: 1px solid $border-color;
}
.editBtn {
  margin-left: 16px;
}
</style>
